var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useState } from 'react';
import { GetTrackShipmentAPI, GetTrackYourtruckAPI, } from '../api/oms/track-package';
export var GetTrackShipmentData = function (requestData) {
    var _a = useState(null), trackShipmentData = _a[0], setTrackShipmentData = _a[1];
    var _b = useState(null), trackShipmentError = _b[0], setTrackShipmentError = _b[1];
    var _c = useState(false), trackShipmentLoaded = _c[0], setTrackShipmentLoaded = _c[1];
    var handleTrackShipmentAPIButtonClick = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, GetTrackShipmentAPI(requestData)];
                case 1:
                    response = _b.sent();
                    setTrackShipmentData((_a = response.data) === null || _a === void 0 ? void 0 : _a.shipmentTrackingDetail);
                    setTrackShipmentLoaded(true);
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _b.sent();
                    setTrackShipmentError(error_1);
                    setTrackShipmentLoaded(true);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return {
        trackShipmentData: trackShipmentData,
        trackShipmentError: trackShipmentError,
        trackShipmentLoaded: trackShipmentLoaded,
        handleTrackShipmentAPIButtonClick: handleTrackShipmentAPIButtonClick,
    };
};
// we will be using order-service api for this
export var GetTrackYourTruckData = function (requestData) {
    var _a = useState(null), trackYourTruckData = _a[0], setTrackYourTruckData = _a[1];
    var _b = useState(null), trackYourTruckError = _b[0], setTrackYourTruckError = _b[1];
    var _c = useState(false), trackYourTruckLoaded = _c[0], setTrackYourTruckLoaded = _c[1];
    var handleTrackYourTruckAPICall = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, GetTrackYourtruckAPI(requestData)
                    .then(function (response) {
                    setTrackYourTruckData(response.data);
                })
                    .catch(function (error) {
                    setTrackYourTruckError(error);
                })
                    .finally(function () { return setTrackYourTruckLoaded(true); })];
        });
    }); };
    return {
        trackYourTruckData: trackYourTruckData === null || trackYourTruckData === void 0 ? void 0 : trackYourTruckData.trackYourTruckResponse,
        trackYourTruckError: trackYourTruckError,
        trackYourTruckLoaded: trackYourTruckLoaded,
        handleTrackYourTruckAPICall: handleTrackYourTruckAPICall,
    };
};
